// src/api/apiClient.js
import axios from 'axios';
import API_SETTINGS from './settingsApi';

// Singleton-промис текущего re-auth. Все параллельные 401 ждут одного и того же
// re-auth, не дёргают /auth/telegram N раз.
let _refreshPromise = null;

// initData мини-аппа всегда доступен пока юзер внутри Telegram Mini App.
const getInitData = () => {
    try {
        if (typeof window === 'undefined') return '';
        return (
            window.Telegram?.WebApp?.initData ||
            window.Telegram?.WebView?.initData ||
            ''
        );
    } catch {
        return '';
    }
};

const reAuth = () => {
    if (_refreshPromise) return _refreshPromise;

    const initData = getInitData();
    if (!initData) {
        return Promise.reject(new Error('NO_INIT_DATA'));
    }

    // raw axios.post — без интерцепторов, чтобы не зациклиться
    _refreshPromise = axios
        .post(
            `${API_SETTINGS.getBaseUrl('auth')}/telegram`,
            { initData },
            {
                withCredentials: true,
                headers: { 'Content-Type': 'application/json' },
            },
        )
        .finally(() => {
            setTimeout(() => { _refreshPromise = null; }, 0);
        });

    return _refreshPromise;
};

const isAuthEndpointUrl = (config) => {
    const full = `${config?.baseURL || ''}${config?.url || ''}`;
    return /\/auth\/(telegram|me)(\?|$|\/)/.test(full);
};

const apiClient = (subdomain) => {
    const baseURL = API_SETTINGS.getBaseUrl(`${subdomain}`);

    const instance = axios.create({
        baseURL,
        headers: { 'Content-Type': 'application/json' },
        withCredentials: true,
    });

    instance.interceptors.request.use(
        (config) => config,
        (error) => Promise.reject(error),
    );

    instance.interceptors.response.use(
        (response) => response,
        async (error) => {
            const original = error?.config;
            const status = error?.response?.status;

            if (status !== 401 || !original || isAuthEndpointUrl(original) || original._authRetried) {
                return Promise.reject(error);
            }

            try {
                await reAuth();
            } catch (reAuthErr) {
                console.warn('Silent re-auth failed:', reAuthErr?.message || reAuthErr);
                return Promise.reject(error);
            }

            original._authRetried = true;
            return instance.request(original);
        },
    );

    return instance;
};

export { getInitData, reAuth };
export default apiClient;
